export enum CommunicationTypeEnum {
  OutboundEmail,
  OutboundCallWithMember,
  InPerson,
  SMS,
  All,
  None,
  OutboundCallNoAnswer,
  LeftVoicemail,
  InboundCall,
  InboundEmail,
  MemberResponseToStaff,
  StaffResponseToMember
}

export const CommunicationTypeStringEnum = {
  OutboundEmail: 'Outbound Email',
  OutboundCallWithMember: 'Outbound Call with Member',
  InPerson: 'In Person',
  SMS: 'SMS',
  All: 'All',
  None: 'None',
  OutboundCallNoAnswer: 'Outbound Call - No Answer',
  LeftVoicemail: 'Left Voicemail',
  InboundCall: 'Inbound Call ',
  InboundEmail: 'Inbound Email',
  MemberResponseToStaff: 'Member Response to Staff',
  StaffResponseToMember: 'Staff Response to Member'
};
